module.exports = __webpack_public_path__ + "static/media/back.ecb4c4f1.jpg";